const NoAvailableTestCase = () =>
  <>
    If your new test case is not listed above, please
    refresh this page. Save your test config beforehand
    to avoid losing changes.
  </>

export default NoAvailableTestCase
